/**
 * Capacità prenotabile (ospiti) vs totale legale a bordo.
 *
 * - `max_capacity` = totale legale di persone a bordo (incl. equipaggio).
 * - `max_guests`   = posti PRENOTABILI dai clienti (ospiti). Se NULL → fallback
 *   a max_capacity (backward compat per i record creati prima del campo).
 *
 * Valido sia per barche (noleggio/locazione) sia per escursioni/esperienze.
 * Booking validation, filtro ricerca e display "fino a N ospiti" usano questo.
 */

interface CapacitySource {
  max_guests?: number | null;
  max_capacity?: number | null;
}

/** Posti prenotabili effettivi (ospiti). null se nessuna capacità nota. */
export function bookableCapacity(e: CapacitySource): number | null {
  if (e.max_guests != null) return e.max_guests;
  return e.max_capacity ?? null;
}

/** True se i `guests` richiesti rientrano nei posti prenotabili. */
export function fitsBookable(e: CapacitySource, guests: number): boolean {
  const cap = bookableCapacity(e);
  if (cap == null) return true; // nessun limite noto → non bloccare
  return guests <= cap;
}
